
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/opleidingen/[uid]/reviews/formulier",
      function () {
        return require("private-next-pages/opleidingen/[uid]/reviews/formulier.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/opleidingen/[uid]/reviews/formulier"])
      });
    }
  